import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { TriggerService } from '../../services';
import { types as actions, editedTriggerAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_TRIGGER),
    switchMap(action =>
      TriggerService.edit(action.trigger, store).pipe(
        map(data => editedTriggerAction(data)),
        catchError(retryAuthentication(action$, 'epics/triggers/editTrigger'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/triggers/editTrigger.js